import React from 'react';
import { injectIntl, FormattedNumber } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { Row, Col, Label, Overlay, Popover } from 'react-bootstrap';
import moment from 'moment';
import 'moment-timezone';
import { getColor } from 'helpers/charts';
import generateId from 'helpers/id';
import OrderInfosBudget from 'components/layout/order/OrderInfosBudget';
import IntlDate from 'components/layout/IntlDate';
import IntlDateRelative from 'components/layout/IntlDateRelative';
import { forEach as _forEach } from 'lodash';
import IntlDateTime from 'components/layout/IntlDateTime';
import { connect } from 'react-redux';
import { getPDFR, setVariables } from '../../../actions/CampaignActions';

class LeadBudget extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showColorSelector: false,
      pickerId: generateId('color-picker-'),
    };

    this.colorSelectorRef = React.createRef();
  }

  showColorSelector = () => {
    this.setState({ showColorSelector: true });
  };

  closeColorSelector = () => {
    this.setState({ showColorSelector: false });
  };

  selectColor = color => {
    const { updateEntity } = this.props;
    this.closeColorSelector();
    updateEntity('color', color * 10 + 1);
  };

  getPDF = (type, editionId) => {
    const {
      intl: { messages },
    } = this.props;
    // set previewing to editionID
    this.props.setVariables(editionId);
    let api = 'previewcopies';
    if (type === 'print') {
      api = 'mastercopies';
    } else if (type === 'image') {
      api = 'images/mastercopies';
    }
    const { getPDFR } = this.props;
    getPDFR(api, editionId, messages);
  };

  render() {
    const {
      intl: { messages },
      entity,
      entityLoaded,
      inModal,
    } = this.props;

    const { showColorSelector, pickerId } = this.state;

    const order = entityLoaded && entity.getOrders()[0];

    const editionId = entityLoaded && order.items[0].edition.id;

    const detailedOrders = [];

    if (entityLoaded) {
      _forEach(entity.getOrders(), order => {
        const detailedOrder = [];
        _forEach(order.getItems(), item => {
          const tempVariantAttributes = [];
          if (item.getVariant()) {
            const attributes = item.getVariant().getAttributes();
            if (attributes && attributes.length > 0) {
              _forEach(attributes, attribute => {
                const attributeNames = attribute.getName();
                const attributeValues = attribute.getValues();
                if (attributeNames && attributeValues && attributeNames.length <= attributeValues.length) {
                  _forEach(attributeNames, (attributeName, l) => {
                    const name = attributeName.getName();
                    const values = attributeValues[l].getValue();
                    if (name && values && values.length > 0) {
                      const value = values[0].getName();
                      if (value) {
                        tempVariantAttributes.push(name + ': ' + value);
                      }
                    }
                  });
                }
              });
            }
          }

          const htmlItem = Math.min(1, item.getQuantity()) + ' x ' + item.getName();
          let htmlDescription = item.getDescription() ? item.getDescription() : '';
          if (tempVariantAttributes.length > 0) {
            htmlDescription += (htmlDescription.length > 0 ? ', ' : '') + tempVariantAttributes.join(', ');
          }
          detailedOrder.push(
            <div>
              <ul>
                <li>
                  <dd dangerouslySetInnerHTML={{ __html: htmlItem }} />
                  <dd dangerouslySetInnerHTML={{ __html: htmlDescription }} />
                </li>
              </ul>
            </div>
          );
        });

        detailedOrders.push(
          <div>
            <dd className="m-t-5">{detailedOrder}</dd>
          </div>
        );
      });
    }

    const colors = Array(9)
      .fill(null)
      .map((_, i) => i);

    if (entityLoaded) {
      const momentWeekAgo = moment()
        .subtract(7, 'days')
        .startOf('day');
      const createdDate = moment(entity.getCdate()).isAfter(momentWeekAgo) ? (
        <IntlDateRelative date={entity.getCdate()} />
      ) : (
        <IntlDate date={entity.getCdate()} />
      );

      let status;
      if (entity.getIsWon()) {
        status = (
          <Label bsStyle="success" className="m-r-20" style={{ fontSize: 'inherit' }}>
            {messages.won}
          </Label>
        );
      } else if (entity.getIsLost()) {
        status = (
          <Label bsStyle="danger" className="m-r-20" style={{ fontSize: 'inherit' }}>
            {messages.lost}
          </Label>
        );
      } else if (entity.getIsDeleted()) {
        status = (
          <Label bsStyle="danger" className="m-r-20" style={{ fontSize: 'inherit' }}>
            {messages.deleted}
          </Label>
        );
      } else {
        status = (
          <Label bsStyle="info" className="m-r-20" style={{ fontSize: 'inherit' }}>
            {messages.open}
          </Label>
        );
      }

      const HeaderComponent = inModal ? 'h5' : 'h3';

      return (
        <div className="clearfix">
          <HeaderComponent>
            {status}
            <span>
              <i
                class="fad fa-circle cursor"
                style={{ color: '#' + getColor(entity.getColor(), 81) }}
                ref={this.colorSelectorRef}
                onClick={this.showColorSelector}
              />{' '}
              {entity.getTitle()}
            </span>
            <span className="hint-text fs-13">
              <i className="fa fa-calendar m-r-5 m-l-15" />
              {createdDate}
            </span>
          </HeaderComponent>
          <Row>
            <Col {...(inModal ? { xs: 12 } : { xs: 12, sm: 4 })}>
              <div className="card card-default bg-master-lighter padding-20 sm-padding-10 b-rad-sm">
                <div className="font-secondary fs-12 all-caps m-b-10">
                  <dt>
                    <span>Bestellung</span>
                  </dt>
                  <dd>
                    <span>{order.id}</span>
                  </dd>
                  <div className="clientInfosBudget m-t-10">
                    <dt className="m-t-10">{messages.client_name}</dt>
                    <dd>
                      <span>{order.creator.getProfile().firstName}</span>
                      <span>{order.creator.getProfile().lastName}</span>
                    </dd>
                    <dt className="m-t-5">{messages.address}</dt>
                    <dd>
                      <span>{order.creator.getProfile().street} </span>
                      <span>{order.creator.getProfile().houseNumber}</span>
                    </dd>
                    <dd>
                      <span>{order.creator.getProfile().zipCode} </span>
                      <span>{order.creator.getProfile().city}</span>
                    </dd>
                    <dt className="m-t-5">Email</dt>
                    <dd>
                      <span>{order.creator.getProfile().email} </span>
                    </dd>
                  </div>
                  <dt className="m-t-10">{messages.date_created}</dt>
                  <dd>
                    <IntlDateTime date={order.getCdate()} />
                  </dd>
                  <dt className="m-t-5">{messages.salesDoc.total_due}</dt>
                  <dd>
                    <FormattedNumber value={order.getSumGross()} style="currency" currency={order.getCurrency()} />
                  </dd>
                </div>
              </div>
            </Col>
            <Col {...(inModal ? { xs: 12 } : { xs: 12, sm: 4 })}>
              <div className="card card-default bg-master-lighter padding-20 sm-padding-10 b-rad-sm">
                <div className="font-secondary fs-12 all-caps m-b-10">
                  <div>
                    <dt>
                      <span>{messages.invoice_address}</span>
                    </dt>
                    <dd className="m-t-5">
                      <span>{order.invoiceAddress.addressData.company}</span>
                    </dd>
                    <dd>
                      <span>{order.invoiceAddress.addressData.firstName} </span>
                      <span>{order.invoiceAddress.addressData.lastName}</span>
                    </dd>
                    <dd>
                      <span>{order.invoiceAddress.addressData.street} </span>
                      <span>{order.invoiceAddress.addressData.houseNumber}</span>
                    </dd>
                    <dd>
                      <span>{order.invoiceAddress.addressData.zipCode} </span>
                      <span>{order.invoiceAddress.addressData.city}</span>
                    </dd>
                    <dd>
                      <span>{order.invoiceAddress.addressData.email} </span>
                    </dd>
                  </div>
                  <div>
                    <dt className="m-t-15">
                      <span>{messages.deliver_adress}</span>
                    </dt>
                    <dd className="m-t-5">
                      <span>{order.shippingAddress.addressData.company}</span>
                    </dd>
                    <dd>
                      <span>{order.shippingAddress.addressData.firstName} </span>
                      <span>{order.shippingAddress.addressData.lastName}</span>
                    </dd>
                    <dd>
                      <span>{order.shippingAddress.addressData.street} </span>
                      <span>{order.shippingAddress.addressData.houseNumber}</span>
                    </dd>
                    <dd>
                      <span>{order.shippingAddress.addressData.zipCode} </span>
                      <span>{order.shippingAddress.addressData.city}</span>
                    </dd>
                    <dd>
                      <span>{order.shippingAddress.addressData.email} </span>
                    </dd>
                  </div>
                </div>
              </div>
            </Col>
            <Col {...(inModal ? { xs: 12 } : { xs: 12, sm: 4 })}>
              <div className="card card-default bg-master-lighter padding-20 sm-padding-10 b-rad-sm">
                <div className="font-secondary fs-12 all-caps m-b-10">
                  <OrderInfosBudget
                    entity={entity.getOrders()[entity.getOrders().length - 1]}
                    entityLoaded={entityLoaded}
                    addEditAction
                    inModal={inModal}
                    pipeline={entity?.getPipeline?.()}
                  />
                </div>
              </div>
            </Col>
          </Row>
          <Row className="m-b-20">
            <Col {...(inModal ? { xs: 12 } : { xs: 12, sm: 4 })}>
              <dt className="m-t-15">
                <span>{messages.ordered_items}</span>
              </dt>
              {detailedOrders}
            </Col>
            <Col {...(inModal ? { xs: 12 } : { xs: 12, sm: 4 })}>
              <dt className="m-t-15">
                <span>{messages.shipping_method}</span>
              </dt>
              <dd>
                <span>{order.shipping}</span>
              </dd>
            </Col>
            <Col {...(inModal ? { xs: 12 } : { xs: 12, sm: 4 })}>
              <dt className="m-t-15">
                <span>{messages.preview_pdf}</span>
              </dt>

              <a className="budgetCheckPDFPreview" target="_blank" onClick={() => this.getPDF('preview', editionId)}>
                {this.props.previewingR === editionId && (
                  <span>
                    <i className="fa fa-spin fa-spinner-third" />{' '}
                  </span>
                )}
                <i className="fal fa-file-pdf" />
                Download {messages.preview_pdf}
              </a>
            </Col>
          </Row>

          <Overlay
            show={showColorSelector}
            target={this.colorSelectorRef.current}
            placement="bottom"
            rootClose
            onHide={this.closeColorSelector}
          >
            <Popover id={pickerId} style={{ maxWidth: 'none', zIndex: 1200 }}>
              <Row style={{ width: '140px' }}>
                {colors.map(color => {
                  return (
                    <Col xs={4} className="no-padding text-center" key={color}>
                      <HeaderComponent>
                        <i
                          class="fad fa-circle cursor"
                          style={{ color: '#' + getColor(color * 10 + 1, 81) }}
                          onClick={() => this.selectColor(color)}
                        />
                      </HeaderComponent>
                    </Col>
                  );
                })}
              </Row>
            </Popover>
          </Overlay>
        </div>
      );
    }

    return null;
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getPDFR: (data, datab, messages) => {
      dispatch(getPDFR(data, datab, messages));
    },
    setVariables: data => {
      dispatch(setVariables(data));
    },
  };
};

const mapStateToProps = state => {
  return {
    user: state.login.user,
    previewingR: state.campaigns.previewingR,
  };
};

export default withRouter(
  injectIntl(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(LeadBudget)
  )
);
